import { css } from 'lit';
export default css ` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #ICON
\*------------------------------------ */
/**
 * Icons span wrapper
 */
.cat-c-icon {
  display: var(--cat-icon-display, block);
}

/**
   * To orient the icons when RTL is applied 
   */
.cat-c-icon-bi-directional {
  transform: rotateY(var(--rtlRotate180, 0));
}

/**
* To display default icon before RTL
*/
.cat-c-ltr-icon {
  display: var(--rtlDisplayNone, block);
}

/**
* To display icon after RTL
*/
.cat-c-rtl-icon {
  display: var(--rtlDisplayBlock, none);
}

/**
 * 1) Graphic used to supplement text or represent functionality
 */
::slotted(svg),
svg {
  display: block;
  fill: var(--cat-icon-fill, currentColor);
  height: var(--cat-icon-height, calc(var(--size-base-unit) * 2));
  width: var(--cat-icon-width, calc(var(--size-base-unit) * 2));
  /**
  * Small icon
  */
  /**
  * Large icon
  */
  /**
  * Extra large icon
  */
}
.cat-c-icon--sm ::slotted(svg),
.cat-c-icon--sm svg {
  height: calc(var(--size-base-unit) * 1.5);
  width: calc(var(--size-base-unit) * 1.5);
}
.cat-c-icon--lg ::slotted(svg),
.cat-c-icon--lg svg {
  height: calc(var(--size-base-unit) * 3);
  width: calc(var(--size-base-unit) * 3);
}
.cat-c-icon--xl ::slotted(svg),
.cat-c-icon--xl svg {
  height: calc(var(--size-base-unit) * 4);
  width: calc(var(--size-base-unit) * 4);
}

/**
 * Icon fill content strong
 */
.cat-c-icon--content-strong {
  --cat-icon-fill: var(--cat-theme-color-content-strong);
}

/**
 * Icon fill knockout
 */
.cat-c-icon--knockout {
  --cat-icon-fill: var(--cat-theme-color-content-knockout);
}

/**
 * Icon fill knockout brand
 */
.cat-c-icon--knockout-brand {
  --cat-icon-fill: var(--cat-theme-color-content-knockout-brand);
}

/**
 * Icon fill information
 */
.cat-c-icon--information {
  --cat-icon-fill: var(--cat-theme-color-content-utility-information);
}

/**
 * Icon fill success
 */
.cat-c-icon--success {
  --cat-icon-fill: var(--cat-theme-color-content-utility-success);
}

/**
 * Icon fill warning
 */
.cat-c-icon--warning {
  --cat-icon-fill: var(--cat-theme-color-content-utility-warning);
}

/**
 * Icon fill error
 */
.cat-c-icon--error {
  --cat-icon-fill: var(--cat-theme-color-content-utility-error);
}
`;
